// @ts-nocheck
import $api from '../services/api.service';
import { of as observableOf } from 'rxjs';
import {
    catchError,
    pluck
} from 'rxjs/operators';

export async function validateCode(params: any[]): Promise<boolean> {
    if (params.length < 1) {
        return false;
    }
    const code: string = params[0];
    const id = params[1]; //'5ec22luao4gmpqin34na';
    return new Promise((resolve, reject) => {
        const returnResult: (res: any) => void = this.returnResult;
        $api
            .findByTermAsync<{ isValid: boolean; }>(
                `accesscode/${id}/validate`,
                { code: code.trim() }
            )
            .pipe(pluck('isValid'),
                catchError(() => {
                    returnResult(false);
                    return observableOf(false);
                }))
            .subscribe(data => {
                if (data) {
                    returnResult(data);
                    resolve(data);
                }
            });
    });
}

export function timestamp(): string {
    const res = new Date();
    return res.toLocaleString('en-US');
}